<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Christmas Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              disabled label="UID:"
              v-model.trim="model.uid"
              hide-details
              outlined
              dense
              v-ascii-only
            />
          </v-col>
          <v-col>
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col>
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>

        <v-row>
          <v-expansion-panels>
            <r-bundle-christmas-panel :items="model.offers" />
          </v-expansion-panels>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundleChristmas} from "@/modules/redactor/models/smart-offer/bundle-christmas/SmartOfferBundleChristmas";

import RBundleChristmasPanel from "@/modules/redactor/views/smart-offer/bundle-christmas/r-bundle-christmas-panel.vue";

export default {
  name: "r-smart-offer-bundle-christmas",
  components: {RBundleChristmasPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleChristmas(),
    rules: ViewRules.READONLY,
  }),

  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleChristmas();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
      },
    discard() {
      this.dialog = false;
      },
    onenter() {
      this.save();
    }
  },


}
</script>



